const state = {
  token: null,
  isSidebarVisible: false,
  isClearCacheVisible: false,
};

const getters = {
  isSidebarVisible: (state) => state.isSidebarVisible,
  isClearCacheVisible: (state) => state.isClearCacheVisible,
};

const actions = {
  setToken({ commit }, token) {
    commit('SET_TOKEN', token);
  },
  showSidebar({ commit }) {
    commit('SHOW_SIDEBAR', true);
  },
  hideSidebar({ commit }) {
    commit('SHOW_SIDEBAR', false);
  },
  showClearCache({ commit }) {
    commit('SHOW_CLEARCACHE', true);
  },
};

const mutations = {
  SET_TOKEN(state, token) {
    state.token = token;
  },
  SHOW_SIDEBAR(state, show) {
    state.isSidebarVisible = show;
  },
  SHOW_CLEARCACHE(state, show) {
    state.isClearCacheVisible = show;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
